import { useDiscoveryContext } from "@iliotech/watchlist-api";
import s from "./Cells.module.scss";
import cn from "classnames";
import { Checkbox } from "@progress/kendo-react-inputs";

export const RankingCell = ({
  dataItem,
}: {
  dataItem: {
    ranking: 9;
    instrumentId: "11831";
    label: "ALEC";
    icon: "images/logos/iex/ALEC.png";
    "Largest Market Out and Under Performers": "-52.2%";
    "Total 1 Yr Return": "-38.9%";
    "Potential breakouts": "+77.3%";
    "Potential breakdowns": "+34.2%";
    "Average Up Day Price Move": "3.0%";
    "Average Down Day Price Move": "-3.6%";
    "Up Days": "134";
    "Down Days": "116";
  };
}) => {
  const discoveryContext = useDiscoveryContext();

  // If context is not available, render just the ranking number
  if (!discoveryContext) {
    return <div className={s.rankingCell}>#{dataItem.ranking}</div>;
  }

  const { isToggled, toggleItem, compare, togglesArray, clearToggles } =
    discoveryContext;
  const onCheck = () => {
    if (compare && togglesArray.length === 1) {
      clearToggles();
      return;
    }
    toggleItem(dataItem.instrumentId!);
  };
  const checked = isToggled(dataItem.instrumentId!);

  return (
    <div className={s.rankingCell}>
      <Checkbox checked={checked} onClick={onCheck} /> #{dataItem.ranking}{" "}
    </div>
  );
};
